import { UPDATE_DIAGNOSIS_RESULT, RESET_DIAGNOSIS_RESULT } from '../constants';

export default (state = {}, action) => {
  switch (action.type) {
    case `${UPDATE_DIAGNOSIS_RESULT}`: {
      const diagnosisResult = action.payload;
      if (diagnosisResult.error) return state;
      return { ...state, ...diagnosisResult };
    }
    case `${RESET_DIAGNOSIS_RESULT}`: {
      return {};
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/diagnosisResult.js